module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Fasting for Miracles")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "contributors"
    }
  }, [_c('p', {
    staticClass: "tx2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_i",
      "title": "i"
    }
  }, [_vm._v("You were made to encounter the God of miracles. In her new book, Tammy Hotsenpiller will lead you into a place of deeper trust, obedience, and faith as you learn to seek God through a season of fasting. "), _c('i', [_vm._v("Fasting for Miracles")]), _vm._v(" will stir your faith for the miraculous and take you closer to the only One who can do the impossible. I recommend this book to every believer who wants to encounter more of God!")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HÉ")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HN")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENIOR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTOR")]), _vm._v(", H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARVEST")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCK")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")]), _vm._v(", P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASADENA")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALIFORNIA")]), _vm._v("; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESIDENT")]), _vm._v(", H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARVEST")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERNATIONAL")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISTRY")]), _vm._v("; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERNATIONAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANCELLOR")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGNER")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIVERSITY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("The Holy Spirit is palpable in the pages of "), _c('i', [_vm._v("Fasting for Miracles")]), _vm._v(". Tammy Hotsenpiller guides the reader on a spiritual exploration of their faith, commitment, and devotion to God as they fast for twenty-one days, seeking His voice and divine intervention through Scripture and prayer. She also brings to light the incredible truth that the enemy tries so hard to suppress, which is that miracles are not just for biblical times, but for "), _c('i', [_vm._v("today")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her message is to seek God in our purest form and call for nationwide prayer and fasting—an anointed message and Spirit-filled act of faith, affirming our belief that God does and will perform miracles for those who are obedient to His will and "), _c('i', [_vm._v("believe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CARLETT")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAIRMAN AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDER")]), _vm._v(", H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LORY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISTRIES")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("Almost everyone I talk to needs a miracle right now, but so many people will possibly wait in a type of hope in the same way that lottery ticket purchasers wait for their ticket numbers to be called—it’s not an activated, faith-filled process so it won’t give them the result they are desperate for. Those who get miracles that are consistent are some of the most deliberate people I know, and this book by Tammy will put you "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ii",
      "title": "ii"
    }
  }, [_vm._v("on track to love a lifestyle of miracles if you will embrace the sacrificial life of fasting. She lays it out beautifully and makes it simple, and I was reignited while going through it for my own lifestyle of fasting. I highly recommend this for families, group study, and everyone who wants more access to the divine nature of Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAWN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLZ")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("TV H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v("; A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")]), _vm._v("; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODCASTER")]), _vm._v("; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETIC")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OICE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("I have had the honor of receiving this phenomenal book, and I have to say, what an insightful and provoking read it is! In "), _c('i', [_vm._v("Fasting for Miracles")]), _vm._v(", Tammy Hotsenpiller leads you on a step-by-step guide of how to skillfully open the door to the miracles of God in your life. You’ll be strengthened in your belief that all things are truly possible and equipped with the insight on how to get God’s attention.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONATHAN")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SAAC")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("NBA F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORWARD")]), _vm._v(", O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLANDO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGIC")]), _vm._v("; A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")]), _vm._v(", "), _c('i', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY")]), _vm._v(" I S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("Fasting is not simply a strike from eating food. It is a demand placed upon heaven for breakthrough, healing, deliverance, signs, and wonders. In this book, Tammy will challenge and encourage you to incorporate the lost art of fasting into the rhythm of your life. Expect a miracle!")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EUCHT")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDER")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("My friend Tammy Hotsenpiller is a prayer warrior! She is the person you call when you want someone to pray for you, and you know without a doubt she will. She has lived the message of her new book, "), _c('i', [_vm._v("Fasting for Miracles,")]), _vm._v(" for many years. Her experience and wisdom and the depth of her prayer life are evident in this book. This message will increase your prayer life and your hunger to see God move in miraculous ways!")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IM")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALKER")]), _vm._v("-S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MITH")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORSHIP")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RTIST")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iii",
      "title": "iii"
    }
  }, [_vm._v("I am honored to endorse my friend Tammy Hotsenpiller’s new book, "), _c('i', [_vm._v("Fasting for Miracles")]), _vm._v(". There are few in my life who understand the importance and significance of fasting like Tammy does. She has taught on and studied this subject matter for years, and there is tremendous fruit as a result. Tammy truly walks this out in her own life and ministry. This book will cause you to grow and go deeper in your walk, as well as equip you to be set up for success as a believer in this critical hour. I highly encourage you to read this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODD")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCONATO")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDER")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODD")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCONATO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISTRIES")]), _vm._v(";")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(", "), _c('i', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODD")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCONATO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOW")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 57
// module chunks = 0